import { render, staticRenderFns } from "./Matriz.vue?vue&type=template&id=34a94881&"
import script from "./Matriz.vue?vue&type=script&lang=js&"
export * from "./Matriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports